import { render, staticRenderFns } from "./logicCriticalThinking.vue?vue&type=template&id=36c771fb&"
import script from "./logicCriticalThinking.vue?vue&type=script&lang=js&"
export * from "./logicCriticalThinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports